<!-- 2.11 产品管理-产品列表增加生产企业管理，能够对生产企业进行新增、修改、删除以及查询-->
<!--产品管理 产品列表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="生产企业名称：">
            <el-input size="medium" placeholder="请输入生产企业名称" v-model="searchForm.SOURCE_COMPANY" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="queryData()">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addData()">新增</el-button>
        <download-json-to-excel disabled ref="download" plain text="导出" @click="exportData()" :loading="loading" :header="downloadHeader"
          fileName="生产企业.xlsx" size="medium">
        </download-json-to-excel>
        <el-button size="medium" @click="() => { importDialog = true }">批量导入</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="SOURCE_ID" label="生产企业ID"></el-table-column>
          <el-table-column prop="SOURCE_COMPANY" label="生产企业名称" min-width="150"></el-table-column>
          <el-table-column prop="CERT_CODE" label="生产许可证编号"></el-table-column>
          <el-table-column prop="CONTACT_PHONE" label="联系电话"></el-table-column>
          <el-table-column prop="CONTACT_PERSON" label="联系人"></el-table-column>
          <el-table-column fixed="right" label="操作" width="300px">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editData(scope.row)">修改</el-button>
              <el-button size="small" type="text" @click="deleteData(scope.row)">删除</el-button>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog title="新增生产企业" :visible.sync="添加生产企业模态框" width="500px">
      <el-form size="medium" :model="新增生产企业表单" ref="新增生产企业表单" :rules="rules" label-width='150px'>
        <el-form-item label="生产企业名称：" prop="SOURCE_COMPANY">
          <el-input v-model="新增生产企业表单.SOURCE_COMPANY" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="生产许可证编号：" prop="CERT_CODE">
          <el-input v-model="新增生产企业表单.CERT_CODE" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="CONTACT_PERSON">
          <el-input v-model="新增生产企业表单.CONTACT_PERSON" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="CONTACT_PHONE">
          <el-input v-model="新增生产企业表单.CONTACT_PHONE" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="添加生产企业模态框 = false">取 消</el-button>
        <el-button size="small" @click="新增生产企业信息()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改生产企业" :visible.sync="修改生产企业模态框" width="500px">
      <el-form size="medium" :model="修改生产企业表单" ref="修改生产企业表单" :rules="rules" label-width='150px'>
        <el-form-item label="生产企业名称：" prop="SOURCE_COMPANY">
          <el-input v-model="修改生产企业表单.SOURCE_COMPANY" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="生产许可证编号：" prop="CERT_CODE">
          <el-input v-model="修改生产企业表单.CERT_CODE" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="CONTACT_PERSON">
          <el-input v-model="修改生产企业表单.CONTACT_PERSON" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="CONTACT_PHONE">
          <el-input v-model="修改生产企业表单.CONTACT_PHONE" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改生产企业模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改生产企业信息()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="importDialog" title="批量导入生产企业" width="400px" center>
      <el-form>
        <upload-excel-to-json @change="(e) => uploadDataChange(e)"
          :option="{ header: ['SOURCE_COMPANY', 'CERT_CODE', 'CONTACT_PHONE', 'CONTACT_PERSON'] }"
          :templateUrl="$util.getURLLocalHost('/file/templates/SCM批量导入批量导入生产企业模板.xlsx')" ref="uploadExcelToJson">
        </upload-excel-to-json>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="importDialog = false">取消</el-button>
        <tooltip-button :disabled="Boolean(uploadData[0])" buttonText="确认" tipContent="请先选择上传文件" buttonClass="operate-btn" @click="confirmUpload()">
        </tooltip-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {

  data() {
    return {
      rules: {
        SOURCE_COMPANY: [
          { required: true, message: '请输入生产企业名称', trigger: 'blur' },
        ],
        CERT_CODE: [
          { required: true, message: '请输入生产许可证编号', trigger: 'blur' },
        ],
      },
      新增生产企业表单: {
        COMPANY_TYPE: 2,
        SOURCE_COMPANY: '',
        CERT_CODE: '',
        CONTACT_PERSON: '',
        CONTACT_PHONE: '',
      },
      添加生产企业模态框: false,
      tableData: [],
      searchForm: {},
      修改生产企业模态框: false,
      修改生产企业表单: {
        COMPANY_TYPE: 2,
        SOURCE_COMPANY: '',
        CERT_CODE: '',
        CONTACT_PERSON: '',
        CONTACT_PHONE: '',
      },
      downloadHeader: {
        SOURCE_COMPANY: '生产企业名称',
        CERT_CODE: '生产许可证编号',
        CONTACT_PHONE: '联系电话',
        CONTACT_PERSON: '联系人',
      },
      loading: false,
      importDialog: false,
      uploadData: [],
    };
  },
  created() {
    this.queryData();
  },
  computed: {

  },
  methods: {
    confirmUpload() {
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 109,
        COMPANY_ID: Number(sessionStorage.getItem('tcId')),
        COMPANY_TYPE: 2, // '公司类型（1：团餐，2：供应）'
        DATA_LIST: this.uploadData.map(({
          SOURCE_COMPANY, CERT_CODE, CONTACT_PHONE, CONTACT_PERSON,
        }) => ({
          SOURCE_COMPANY, CERT_CODE, CONTACT_PHONE, CONTACT_PERSON,
        })),
      };
      http.post(params).then((res) => {
        if (res.length) {
          this.$message.show({ text: '部分导入失败，请检查错误原因', type: 'warning' });
          this.$refs.uploadExcelToJson.downloadErrorInfoFile({ ...this.downloadHeader, REASON: '错误原因' }, [...res], [30, 20, 20, 20, 30]);
          this.$refs.uploadExcelToJson.fileList = [];
        } else {
          this.$message.show({ text: '导入成功', type: 'success' });
        }
        this.importDialog = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    uploadDataChange(data) {
      const list = data.map(({
        SOURCE_COMPANY, CERT_CODE, CONTACT_PHONE, CONTACT_PERSON,
      }) => ({
        SOURCE_COMPANY, CERT_CODE, CONTACT_PHONE, CONTACT_PERSON,
      }));
      list.shift();
      const pass = validation.validateValues(list, this.rules);
      if (pass) {
        this.uploadData = list.map((item, INDEX) => ({ ...item, INDEX }));
      } else {
        this.$message.show({ text: '导入失败，请检查数据格式', type: 'warning' });
        this.$refs.uploadExcelToJson.downloadErrorInfoFile({ ...this.downloadHeader, REASON: '错误原因' }, [...list], [30, 20, 20, 20, 30]);
        this.$refs.uploadExcelToJson.fileList = [];
      }
    },
    async exportData() {
      const data = await this.getData();
      this.$refs.download.download(data.map(({
        SOURCE_COMPANY,
        CERT_CODE,
        CONTACT_PHONE,
        CONTACT_PERSON,
      }) => ({
        SOURCE_COMPANY,
        CERT_CODE,
        CONTACT_PHONE,
        CONTACT_PERSON,
      })), [30, 20, 20, 20]);
    },
    确认修改生产企业信息() {
      this.$refs.修改生产企业表单.validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10202',
            OTYPE: 54,
            COMPANY_ID: Number(sessionStorage.getItem('tcId')), // 生产企业ID
          };
          for (const key in this.修改生产企业表单) {
            if (this.修改生产企业表单[key]) params[key] = this.修改生产企业表单[key];
          }
          http.post(params).then((res) => {
            this.修改生产企业模态框 = false;
            this.$message.show({ text: '修改成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    editData(row) {
      this.修改生产企业模态框 = true;
      this.修改生产企业表单 = { ...row };
    },
    deleteData(row) {
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 55,
        SOURCE_ID: row.SOURCE_ID, // 生产企业ID
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    新增生产企业信息() {
      this.$refs.新增生产企业表单.validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10202',
            OTYPE: 53,
            COMPANY_ID: Number(sessionStorage.getItem('tcId')), // 生产企业ID
          };
          for (const key in this.新增生产企业表单) {
            if (this.新增生产企业表单[key]) {
              params[key] = this.新增生产企业表单[key];
            }
          }
          http.post(params).then((res) => {
            this.新增生产企业表单 = {
              COMPANY_TYPE: 2,
              SOURCE_COMPANY: '',
              CERT_CODE: '',
              CONTACT_PERSON: '',
              CONTACT_PHONE: '',
            };
            this.添加生产企业模态框 = false;
            this.$message.show({ text: '新增成功', type: 'success' });
            this.searchForm.SOURCE_COMPANY = '';
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    addData() {
      this.添加生产企业模态框 = true;
    },
    async queryData() {
      this.tableData = await this.getData();
    },
    async getData() {
      this.loading = true;
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 52,
        COMPANY_ID: Number(sessionStorage.getItem('tcId')), // 生产企业ID
        COMPANY_TYPE: 2, // '公司类型（1：团餐，2：供应）'
      };
      if (this.searchForm.SOURCE_COMPANY) {
        params.SOURCE_COMPANY = this.searchForm.SOURCE_COMPANY; // 生产企业名称
      }
      let list = [];
      await http.post(params).then((res) => {
        list = [...res];
        if (!this.searchForm.SOURCE_COMPANY) sessionStorage.setItem('sourceCompanyList', JSON.stringify(this.$util.listRemoveDuplicates(res)));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.loading = false;
      return list;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/productionEnterpriseManagement.vue